/**

* api接口统一管理

*/

import { get, post } from './http'

//请求接口方法
//post请求模板
export const editHead = p => post('/editHead', p);
export const register = p => post('/register', p);
export const cityInfo = p => post('/cityInfo', p);
export const login = p => post('/login', p);
export const info = p => post('/info', p);
export const walletInfo = p => post('/walletInfo', p);
export const bind = p => post('/bind', p);//绑定钱包地址
export const problemList = p => post('/common/problemList', p); //常见问题
export const contact = p => post('/common/contact'); //客服
export const carousel = p => post('/common/carousel', p); //获取轮播图列表
export const information = p => post('/common/information', p); //活动公告列表
export const convertRecords = p => post('/convertRecords', p); //兑换记录
export const convert = p => post('/convert', p); //兑换
export const editLoginPwd = p => post('/editLoginPwd', p); //修改登录密码
export const payPwd = p => post('/payPwd', p); //设置/修改资金密码
export const forgetPwd = p => post('/forgetPwd', p); //找回密码
export const bindRefer = p => post('/bindRefer', p); //绑定上级
export const withdrawRecord = p => post('/withdrawRecord', p); //提现记录
export const rechargeRecord = p => post('/rechargeRecord', p); //充值记录
export const withdrawPage = p => post('/withdrawPage', p); //提现页面
export const bindWallet = p => post('/bindWallet'); //获取绑定钱包列表
export const recharge = p => post('/recharge'); //充值
export const withdrawCoin = p => post('/withdrawCoin', p); //提现
export const doHashCityInfo = p => post('/doHashCityInfo', p); //下注页面
export const doHashCity = p => post('/doHashCity', p); //下注
export const racingPeriodList = p => post('/racingPeriodList', p); //开奖记录
export const article = p => post('/common/article', p); //开奖记录

export const awardInfo = p => post('/awardInfo'); //奖励-页面信息
export const cashFlow = p => post('/cashFlow', p); //余额明细
export const dealFlow = p => post('/dealFlow', p); //交易明细
export const walletBidFlow = p => post('/walletBidFlow', p); //钱包下注记录
export const myWallet = p => post('/myWallet', p); //我的钱包
export const awardInfoItem = p => post('/awardInfoItem', p); //我的钱包
export const luckyRecordList = p => post('/luckyRecordList', p); //我的钱包
export const batInfo = p => post('/batInfo', p); //投注数据
export const racingRecordList = p => post('/racingRecordList', p); //投注数据
export const transfer = p => post('/transfer', p); //投注数据


export const deleteBidWalletAddress = p => post('/deleteBidWalletAddress', p); //删除绑定地址
export const getSms = p => post('/getSms', p); //获取短信验证码
export const phoneCode = p => post('/common/phoneCode', p); //区号列表
export const bindPhone = p => post('/bindPhone', p); //绑定手机
export const awardRate = p => post('/common/awardRate', p); //绑定手机
export const informationTop = p => post('/common/informationTop', p); //绑定手机
export const promotionTask = p => post('/promotionTask', p); //绑定手机
export const registerAward = p => post('/registerAward', p); //注册送金
export const receiveRegisterAward = p => post('/receiveRegisterAward', p); //领取注册奖励
export const receivePromotionAward = p => post('/receivePromotionAward', p); //领取推广任务奖励
export const img = p => post('/upload/img', p);
export const submitRecharge = p => post('/submitRecharge', p);
export const awardImg = p => post('/common/awardImg', p);





// WEBPACK FOOTER //
// ./src/utils/request.js